import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import PlaylistsTable from './PlaylistsTable';
import FeelLucky from './FeelLucky';

function FeelLuckyModal(props) {
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);


  return (
    <>
    
    <Button variant="primary" onClick={handleShow}>
        {props.linkText}
      </Button>

      <Modal show={showModal} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{props.modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <FeelLucky modalCloser={handleClose} time={props.time}/>

        </Modal.Body>
      </Modal>
    </>
  );
}

export default FeelLuckyModal;
